/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { BubbleMenu } from "@tiptap/react";
import { ImageSettingsDialog } from "./image-settings-dialog";
import { ImageToolTipDisplay } from "cms/rich-text/simplicity-composer-tiptap/image/image-display";

const ImageBubbleMenu = () => {
    
    const markType = "image";
    const [visible,setVisible] = useState(false);
    // const { image,updateImage } = useUpdateImage()
    
    const shouldShow = (properties) => {
        // const { editor, view, state, oldState, from, to } = properties
        const { editor } = properties;
        return editor.isActive(markType);
    };
    
    return (
        // BubbleMenu will fail to remove correctly without a wrapping div
        // https://github.com/ueberdosis/tiptap/issues/2658#issuecomment-1312664934
        <div>
            <BubbleMenu
                updateDelay={100}
                shouldShow={shouldShow}
                tippyOptions={{
                    placement: "bottom",
                    zIndex: 100
                }}
            >
                <ImageToolTipDisplay
                    visible={visible}
                    setVisible={setVisible}
                />
                <ImageSettingsDialog
                    visible={visible}
                    setVisible={setVisible}
                />
            </BubbleMenu>
        </div>
    );
};
export { ImageBubbleMenu };
